module.exports = __webpack_public_path__ + "static/media/4.30b558ae.svg";